import React from 'react';
import { Dialog } from 'primereact/dialog';
import { RateWithDetails } from '../../../../api/types/lecturers/user-details-lecturer';
import { UserPageLecturerRateItem } from '../../../user-page/roles/lecturer-price-rate/componenets/user-page-lecturer-rate-item';
import {
  convertRateWithDetailsToRatesGroup,
  convertRateWithDetailsToUserSummary,
} from './operations/rate-dto';

interface RateDetailsDialogProps {
  visible: boolean;
  onHide: () => void;
  rateWithDetails: RateWithDetails | null;
  onRefresh?: () => Promise<void>;
}

const RateDetailsDialog: React.FC<RateDetailsDialogProps> = ({
  visible,
  onHide,
  rateWithDetails,
  onRefresh,
}) => {
  if (!rateWithDetails) {
    return null;
  }

  const activity = convertRateWithDetailsToRatesGroup(rateWithDetails);
  const user = convertRateWithDetailsToUserSummary(rateWithDetails);

  const handleRefresh = async () => {
    if (onRefresh) {
      await onRefresh();
    }
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      style={{ width: '90vw', maxWidth: '1200px' }}
      header={
        <div style={{ textAlign: 'right', direction: 'rtl' }}>
          <h3 style={{ margin: 0, color: '#185FD3' }}>
            פרטי תעריף - {rateWithDetails.firstName} {rateWithDetails.lastName}
          </h3>
        </div>
      }
      modal
      dismissableMask
      dir="rtl"
      headerStyle={{
        textAlign: 'right',
        direction: 'rtl',
        borderBottom: '1px solid #E5E7EB',
        padding: '1rem 1.5rem',
      }}
      contentStyle={{
        padding: '0',
        direction: 'rtl',
      }}
    >
      <div
        style={{
          padding: '1rem',
          backgroundColor: '#f8fafc',
          minHeight: '400px',
        }}
      >
        <UserPageLecturerRateItem
          index={0}
          activity={activity}
          user={user}
          onRefresh={handleRefresh}
          shouldDisplayFinancials={true}
        />
      </div>
    </Dialog>
  );
};

export default RateDetailsDialog;
